import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../getBaseQuery'

export interface OrangeReportProcessLog {
  id: string
  notes: string
  created_by: string
  updated_by: string
  deleted_by: string | null
  created_at: string
  updated_at: string
  deleted_at: string | null
  institution_id: string
  orange_reports_file_id: string
  status: 'success' | 'failed' | 'processing'
  error_message: string
  remote_log_path: string
}

export interface OrangeReportProcessLogResponse {
  data: {
    records: OrangeReportProcessLog[]
    total_pages: number
    total_records: number
    current_page: number
    current_size: number
  }
  message: string
}

export interface GetOrangeReportProcessLogsParams {
  page?: number
  size?: number
  order?: string
  sortBy?: string
  filter?: string
}

export const orangeReportsApi = createApi({
  reducerPath: 'orangeReportsApi',
  baseQuery,
  tagTypes: ['OrangeReportProcessLog'],
  endpoints: (builder) => ({
    getOrangeReportProcessLogs: builder.query<OrangeReportProcessLogResponse, GetOrangeReportProcessLogsParams>({
      query: ({ page = 0, size = 10, order = 'desc', sortBy = 'created_at', filter }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          size: size.toString(),
          sort_by: `${sortBy}::${order}`,
        })

        if (filter) {
          params.append('filter', filter)
        }

        return `/orange-reports/process-logs?${params.toString()}`
      },
      providesTags: ['OrangeReportProcessLog'],
    }),
  }),
})

export const { useGetOrangeReportProcessLogsQuery } = orangeReportsApi